import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(_route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    }
    // Coming back after the 7-day token ran out is the usual way here (§0cr): say so,
    // and return the user to the page they opened.
    const expired = this.authService.hasExpiredSession();
    // Always, not only when expired: a token removed by another tab (logout there) left
    // the user in memory, and login rendered under "Welcome, Regine" with the full nav.
    this.authService.logout();
    this.router.navigate(['/login'], {
      queryParams: {
        ...(expired ? { reason: 'expired' } : {}),
        ...(state?.url ? { returnUrl: state.url } : {})
      }
    });
    return false;
  }
}
